import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";

// initial state
export const initialState = {
  nutritionist: {}
};

export default {
  state: initialState,
  getters,
  mutations,
  actions,
  modules: {}
};
